/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminManualAcceptClientInput } from "../../entities/models/AdminManualAcceptClientInput";
import { z } from "zod/v4";

export const modelsAdminManualAcceptClientInputSchema = z.object({
    "barber_id": z.int(),
"station_id": z.int()
    }) as unknown as z.ZodType<ModelsAdminManualAcceptClientInput>